import styled from "@emotion/styled";
import { SMART_SIZE } from "../../../styles/common";

export const MyPageLayoutWrapper = styled.div`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  grid-template-areas:
    "header"
    "main"
    "footer";

  height: 100vh;
  height: 100dvh;
  overflow: hidden;
`;

export const CommonLayout = styled.div`
  grid-area: main;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  padding-left: 40px;
  padding-right: 40px;

  ${SMART_SIZE} {
    padding-left: 4%;
    padding-right: 4%;
  }
`;

export const CommonBlockBox = styled.div`
  text-align: center;
`;

// 手机端 Footer 显示/隐藏按钮
export const MobileFooterToggle = styled.button`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;

    position: fixed;
    top: calc(10px + env(safe-area-inset-top, 0px));
    left: 10px;
    z-index: 99999;

    width: 32px;
    height: 32px;
    padding: 0;

    font-size: 14px;
    font-weight: bold;
    color: #333;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 6px;
    cursor: pointer;
  }
`;

// Footer 显示控制
export const FooterContainer = styled.div`
  grid-area: footer;
  min-height: 0;
  display: block;

  @media (max-width: 768px) {
    display: ${({ showFooter }) => (showFooter ? "block" : "none")};
  }
`;
